<template>
<div @click="toPath()" style="cursor: pointer">
  <img :src="imgSrc" :style="{width: width, height: height}">
  <div
      class="img-title"
      :style="{width: `calc(${width} - 20px)`}">
    {{title}}
  </div>
</div>
</template>

<script>
export default {
  name: "img-text",
  props: {
    imgSrc: {
      default: require('@/assets/icon/banner.jpg')
    },
    title: {
      default: ''
    },
    width: {
      default: '380px'
    },
    height: {
      default: '263px'
    },
    id:{

    }
  },
  methods: {
    toPath(){
      if(this.id) {
        console.log(this.id)
        this.$router.push({
          path: '/article-page/'+this.id
        })
      }
    }
  }
}
</script>

<style scoped>
.img-title{
  background: rgba(0,0,0,0.8);
  height: 25px;
  color: white;
  white-space: nowrap;
  overflow-x: hidden;
  padding: 5px 10px;
  text-align: center;
  width: 330px;
  margin-top: -5px;
  text-overflow: ellipsis;
  line-height: 25px;
}
</style>
